import { useCashRegisters } from '@state/cashRegister'

import CashRegisterIcon from '../cashRegister.svg?no-inline'

function CashRegister() {
  const { data: cashRegisters } = useCashRegisters()

  if (!cashRegisters) return null

  const cashRegisterColor = 'var(--color-cash-register)'
  const width = 1.2
  const depth = 3
  const iconSize = 0.7

  return (
    <>
      {cashRegisters.map((cashRegister, i) => {
        const rotationDegrees = (-cashRegister.rotation * 180) / Math.PI

        return (
          <g key={i}>
            <rect
              x={cashRegister.x - width / 2}
              y={cashRegister.y - depth / 2}
              width={width}
              height={depth}
              fill={cashRegisterColor}
              stroke={cashRegisterColor}
              strokeWidth={0.1}
              rx={0.1}
              ry={0.1}
              transform={`rotate(${rotationDegrees}, ${cashRegister.x}, ${cashRegister.y})`}
              vectorEffect="non-scaling-stroke"
            />

            <image
              href={CashRegisterIcon}
              x={cashRegister.x - iconSize / 2}
              y={cashRegister.y - iconSize / 2}
              width={iconSize}
              height={iconSize}
              opacity={0.9}
            />
          </g>
        )
      })}
    </>
  )
}

export default CashRegister